// extracted by mini-css-extract-plugin
export default {"container":"OverviewBanner_container__cVpwC","wrapper":"OverviewBanner_wrapper__ondwX","element":"OverviewBanner_element__3UMqd","value":"OverviewBanner_value__blZsN"};